import { audiencerateApi } from '../../audiencerate';
import { TableResponse } from '../types';
import {
  CampaignResponse,
  CreateCampaignQueryArgs,
  CreateCampaignRequestBody,
  DeleteCampaignArgs,
  GetCampaignArg,
  GetCampaignsArg,
  GetCampaignsCountArg,
  UpdateCampaignArgs,
  UpdateCampaignRequestBody,
} from './types';

export const campaignsApi = audiencerateApi.injectEndpoints({
  endpoints: (build) => ({
    createCampaign: build.mutation<CampaignResponse, CreateCampaignRequestBody & CreateCampaignQueryArgs>({
      query: ({ workspaceId, ...body }) => ({
        url: `/v1/workspaces/${workspaceId}/campaigns`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Campaigns'],
    }),
    getCampaigns: build.query<TableResponse<CampaignResponse>, GetCampaignsArg>({
      query: ({ workspaceId, limit, offset, searchText: search }) => ({
        url: `/v1/workspaces/${workspaceId}/campaigns`,
        params: { limit, offset, search },
      }),
      providesTags: ['Campaigns'],
    }),
    getCampaign: build.query<CampaignResponse, GetCampaignArg>({
      query: ({ workspaceId, campaignId }) => ({
        url: `/v1/workspaces/${workspaceId}/campaigns/${campaignId}`,
      }),
      providesTags: (result, error, args) => [{ type: 'Campaigns', id: args.campaignId }],
    }),
    getCampaignsCount: build.query<number, GetCampaignsCountArg>({
      query: ({ workspaceId, searchText: search, status }) => ({
        url: `/v1/workspaces/${workspaceId}/campaigns/count`,
        params: { search, status },
      }),
      providesTags: ['CampaignsCount'],
    }),
    deleteCampaign: build.mutation<void, DeleteCampaignArgs>({
      query: ({ workspaceId, campaignId }) => ({
        url: `/v1/workspaces/${workspaceId}/campaigns/${campaignId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Campaigns'],
    }),
    updateCampaign: build.mutation<void, UpdateCampaignArgs & UpdateCampaignRequestBody>({
      query: ({ workspaceId, campaignId, ...body }) => ({
        url: `/v1/workspaces/${workspaceId}/campaigns/${campaignId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Campaigns'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateCampaignMutation,
  useGetCampaignsQuery,
  useGetCampaignsCountQuery,
  useLazyGetCampaignsQuery,
  useGetCampaignQuery,
  useDeleteCampaignMutation,
  useUpdateCampaignMutation,
} = campaignsApi;
